import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`
// ;

// Bare client with no interceptors attached, so refreshing never re-enters the
// refresh flow that the interceptors trigger.
const bareAxios = axios.create();

console.log(API_URL, "API_URL")
  export const adminLogin = async (data) => {
    // console.log(data, "data>>>>>>")
    try {
      const response = await axios.post(
        `${API_URL}auth/admin-login`,
          data
      );
      // console.log(response.data, "response return ")
      return response;
    } catch (error) {
      console.error('Error fetching tournaments:', error);
      throw error;
    }
  }

  export const refreshToken = async (token) => {
    try {
      const response = await bareAxios.post(
        `${API_URL}auth/admin-refresh-token`,
        { refreshToken: token }
      );
      return response;
    } catch (error) {
      console.error('Error refreshing token:', error);
      throw error;
    }
  }

  export const switchRole = async (targetRole, token) => {
    try {
      const response = await axios.post(
        `${API_URL}auth/switch-role`,
        { targetRole },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.error('Error switching role:', error);
      throw error;
    }
  }